import React, {SyntheticEvent} from 'react';
import classNames from "classnames";
import {IconProps} from "../icons";


import './ContextMenuItem.css';


export interface ContextMenuItemProps {
    handleClose: () => void;
    onClick?: (event: SyntheticEvent) => boolean | any;
    condition?: boolean;
    text?: string | React.ReactNode;
    Icon?: React.ComponentType<IconProps>;
    ActionIcon?: React.ComponentType<IconProps>;
    action?: () => Promise<void>;
    className?: string;
}

export const ContextMenuItem = (
    {
        handleClose,
        onClick,
        text,
        Icon,
        ActionIcon,
        action,
        className
    }: ContextMenuItemProps) => {
    let content = <>
        {Icon && <Icon className='ctx-menu__item-icon' size={20}/>}
        {text && <span>{text}</span>}
        {ActionIcon && <ActionIcon
            className="ctx-menu__ActionItem-icon"
            size={24}
            additionalPadding={4}
            onClick={async (e) => {
                e.stopPropagation();
                if (action) {
                    await action();
                }
            }}/>
        }
    </>;
    return (
        <div
            className={classNames({
                'ContextMenuItem': true,
                'ContextMenuItem_withPointer': onClick,
                'ContextMenuItem_withIcon': Icon,
                [className!]: className,
            })}
            onClick={(e) => {
                e.stopPropagation();
                if (onClick) {
                    const clickResult = onClick(e);
                    if (clickResult !== false) {
                        handleClose();
                    }
                }
            }}
        >
            {content}
        </div>
    )
}
